import { Box, Field, FieldControl, FieldLabel } from "@prismicio/editor-ui"

import { FieldTextInput } from "../../FieldTextInput"

interface ImageAltControlProps {
  id?: string
  readOnly?: boolean
  altText: string
  onValueChange: (value: string) => void
  selected?: boolean
}

export function ImageAltControl(props: ImageAltControlProps) {
  const { id, readOnly, altText, onValueChange, selected } = props

  return (
    <Field selected={selected}>
      <FieldLabel htmlFor={id}>Alt text</FieldLabel>
      <FieldControl>
        <Box flexGrow={1} height={40}>
          <FieldTextInput
            id={id}
            placeholder="Short description for the visually impaired"
            // TODO: this should be disabled when contentView is undefined, but TextInput doesn't have a disabled prop.
            readOnly={readOnly}
            value={altText}
            onValueChange={onValueChange}
            padding={{ input: { inline: 12 } }}
          />
        </Box>
      </FieldControl>
    </Field>
  )
}
